interface InOpacityList {
  [id: number]: number;
}
const opacityList: InOpacityList = {};
const TWO = 2;

// 展示label
const labelShow = (zr, timer: number) => {
  const { id } = zr;
  if (opacityList[id] === 0) {
    zr.attr('style', {
      opacity: 0
    });
    opacityList[id] = 1;
    zr.animateTo(
      {
        style: {
          opacity: 1
        }
      },
      timer
    );
  } else {
    zr.attr({
      style: {
        opacity: 1
      }
    });
  }
};

// 隐藏label
const labelHide = (zr, timer: number) => {
  const { id } = zr;
  if (opacityList[id] === 1) {
    zr.attr('style', {
      opacity: 1
    });
    opacityList[id] = 0;
    zr.animateTo(
      {
        style: {
          opacity: 0
        }
      },
      timer
    );
  } else {
    zr.attr('style', {
      opacity: 0
    });
  }
};

// 格式化数据
const formatValue = (textZr, rectZr, seriesModel) => {
  const valueZr = textZr._children[1];
  const valueRect = valueZr.getBoundingRect();
  const rectRect = rectZr.getBoundingRect();
  const padding = seriesModel.option.label.disance * TWO;
  const containerWidth = rectRect.width - padding;
  if (valueRect.width >= containerWidth) {
    const valueStyle = textZr.style.rich.value;
    textZr.attr({
      style: {
        rich: {
          value: {
            ...valueStyle,
            fontSize: Math.floor((valueStyle.fontSize * containerWidth) / valueRect.width)
          }
        }
      }
    });
  }
};

// 检查容器高度是否够用
const checkHeight = (textZr, rectZr) => {
  const nameZr = textZr._children[0];
  const valueZr = textZr._children[1];
  const rectRect = rectZr.getBoundingRect();
  const containerHeight = rectRect.height;
  if (containerHeight >= textZr.getBoundingRect().height) {
    // show
    valueZr.show();
    return true;
  }
  if (nameZr && containerHeight >= nameZr.getBoundingRect().height) {
    // show name
    valueZr.hide();
    return true;
  }
  // hide
  return false;
};

// 获取能放下字数
const getStrNumber = (width, name, fontSize) => {
  let nowWidth = 0;
  const reg = /^[\u4e00-\u9fa5]+$/;
  for (let i = 0; i < name.length; i++) {
    if (reg.test(name[i])) {
      // 中文
      nowWidth += fontSize;
    } else {
      // 其他占用半个字符
      nowWidth += fontSize * 0.6;
    }
    if (nowWidth >= width) {
      return i - 1;
    }
  }
};

// 格式化名称
const formatName = (textZr, rectZr, seriesModel) => {
  if (typeof opacityList[textZr.id] !== 'number') {
    opacityList[textZr.id] = 1;
  }
  const { label, animationDurationUpdate } = seriesModel.option;
  const padding = label.disance * TWO;
  const rectRect = rectZr.getBoundingRect();
  const containerWidth = rectRect.width - padding;
  const { text } = textZr.style;
  const name = text.match(/\{name\|([^}]*)\}/)[1];
  const isOverflowY = checkHeight(textZr, rectZr);
  if (
    textZr._children[1] &&
    textZr._children[1].getBoundingRect().width >= containerWidth &&
    name &&
    isOverflowY
  ) {
    // 宽度不够
    const { fontSize } = textZr.style;
    const strNumber = getStrNumber(containerWidth, name, fontSize);

    if (strNumber > 0) {
      // 显示...
      textZr.attr({
        style: {
          text: text.replace(`{name|${name}}`, `{name|${name.substr(0, strNumber)}...}`)
        }
      });
      formatValue(textZr, rectZr, seriesModel);
      labelShow(textZr, animationDurationUpdate);
    } else {
      // 宽度不够隐藏
      labelHide(textZr, animationDurationUpdate);
    }
  } else if (isOverflowY) {
    // 宽度足够，高度足够
    labelShow(textZr, animationDurationUpdate);
    formatValue(textZr, rectZr, seriesModel);
  } else {
    // 高度不够
    labelHide(textZr, animationDurationUpdate);
  }
};

const eachLabel = (data, seriesModel) => {
  if (data._children) {
    data._children.forEach(item => {
      item._parent = data;
      eachLabel(item, seriesModel);
    });
  } else if (data._textContent && data.shape.width > 0 && data.shape.height > 0) {
    data._textContent.getBoundingRect();
    const textZr = data._textContent;
    formatName(textZr, data, seriesModel);
  }
};

const twoLineBasicFn = (group, seriesModel) => {
  eachLabel(group, seriesModel);
};

export default twoLineBasicFn;
